export default __webpack_public_path__ + "static/dipped-a9dcfbb7a19a75945999b735281696e8.png";